import { Component, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { SearchDialogComponent } from '@Work/Accounts/proprietary/controls/search-dialog.component';
import { DataService } from '@Core/services/proprietary/data.service';
import { TaskObjectService } from '../../../../../core/models/proprietary/task/task-object.service';
import { AppService } from '../../../../../core/services/proprietary/app.service';

@Component({
    standalone: false,
    selector: 'document-search-dialog',
    templateUrl: './document-search-dialog.component.html',
    providers: [DataService]
})
export class DocumentSearchDialogComponent extends SearchDialogComponent {
    constructor(
        private injector: Injector,
        private activeModal: NgbActiveModal,
        private store: Store,
        private taskOS: TaskObjectService,
        public app: AppService
    ) {
        super(injector);
    }

    modelChild = {
        showMode: '',
        filedDateRangeCode: '',
        createdDateRangeCode: '',
        Contract_Num: '',
        Entity_Name: '',
        Claim_Num: '',
        quickFilterCodes: []
    };

    //Override Method: called to construct initialize the search component
    initialize(): boolean {
        let criteriaContractID = this.model.criteria.Contract_ID;
        let criteriaContractNum = this.model.criteria.Contract_Num;
        let criteriaEntityID = this.model.criteria.Entity_ID;
        let criteriaEntityName = this.model.criteria.Entity_Name;

        this.parentActiveModal = this.activeModal;
        this.objectType = 'Document';
        this.model.title = 'Select Document';

        this.model.criteria.Max = this.model.currentOptions.maxRows;
        this.model.criteria.json = 'CT2';
        if (!this.model.criteria.View) {
            this.model.criteria.View = 'Full';
        }
        this.modelChild.showMode = 'F';
        this.setShowMode('F');

        if (criteriaContractID && criteriaContractNum) {
            this.dsCollection.criteria.Contract_ID = criteriaContractID;
            this.model.criteria.Contract_ID = criteriaContractID;
            this.dsCollection.criteria.Contract_Scope = 'Rev';
            this.model.criteria.Contract_Scope = 'Rev';
            this.modelChild.Contract_Num = criteriaContractNum;
            this.model.dirty = true;
        }
        if (criteriaEntityID && criteriaEntityName) {
            this.dsCollection.criteria.Entity_ID = criteriaEntityID;
            this.model.criteria.Entity_ID = criteriaEntityID;
            this.modelChild.Entity_Name = criteriaEntityName;
            this.model.dirty = true;
        }

        let filters = [
            { Code: 'F', Code_Desc: 'Filed', Icon: '', Tooltip: 'Filed Only' },
            { Code: 'U', Code_Desc: 'Unfiled', Icon: '', Tooltip: 'Not Filed Only' }
        ];
        if (this.taskOS.currentProjectID) {
            filters.push({ Code: 'P', Code_Desc: 'Project', Icon: '', Tooltip: 'Filed to Current Project' });
        }
        this.modelChild.quickFilterCodes = filters;

        return true;
    }

    entitySelected(data: any) {
        let selectedRole;
        const roles = data[0]?.Roles?.Role;

        if (roles && roles.length > 0) {
            for (const role of roles) {
                if ('Selected' in role && role.Selected) {
                    selectedRole = role.Role_Type;
                    break;
                }
            }

            if (!selectedRole) {
                selectedRole = roles[0].Role_Type;
            }
        }

        this.model.criteria.Role_Type = selectedRole ? selectedRole : '';
    }

    setShowMode(mode: any) {
        this.resetSearch();
        switch (mode) {
            case 'F':
                this.model.criteria.Filed_Ind = 'Y';
                this.modelChild.filedDateRangeCode = 'ANYTIME';
                this.model.criteria.Filed_Date_From = this.app.getCodedDate(this.modelChild.filedDateRangeCode, 'BEGIN');
                this.model.criteria.Filed_Date_To = this.app.getCodedDate(this.modelChild.filedDateRangeCode, 'END');
                this.model.dirty = true;
                break;
            case 'U':
                this.model.criteria.Filed_Ind = 'N';
                this.model.criteria.Filing_User_ID = 'CURRENTUSER';
                this.modelChild.createdDateRangeCode = 'ANYTIME';
                this.model.criteria.Creation_Date_From = this.app.getCodedDate(this.modelChild.createdDateRangeCode, 'BEGIN');
                this.model.criteria.Creation_Date_To = this.app.getCodedDate(this.modelChild.createdDateRangeCode, 'END');
                this.model.dirty = true;
                break;
            case 'P':
                this.model.criteria.Project_ID = this.taskOS.currentProjectID;
                this.model.dirty = true;
                break;
        }
    }

    resetSearch() {
        this.model.criteria.Filed_Ind = null;
        this.modelChild.filedDateRangeCode = null;
        this.model.criteria.Filed_Date_From = null;
        this.model.criteria.Filed_Date_To = null;
        this.modelChild.createdDateRangeCode = null;
        this.model.criteria.Creation_Date_From = null;
        this.model.criteria.Creation_Date_To = null;
        this.model.criteria.Contract_ID = null;
        this.modelChild.Contract_Num = null;
        this.model.criteria.Contract_Scope = null;
        this.model.criteria.Entity_ID = null;
        this.modelChild.Entity_Name = null;
        this.model.criteria.Role_Type = '';
        this.model.criteria.Project_ID = null;
        this.model.criteria.Claim_ID = null;
        this.modelChild.Claim_Num = null;
        this.model.criteria.Filing_User_ID = null;
        this.model.criteria.Doc_Class = '';
        this.model.criteria.File_Drawer = '';
        this.model.criteria.File_Folder = '';
        this.model.criteria.Filing_WorkGroup_ID = null;
        this.dsCollection.reset();
        this.model.dirty = true;
    }

    refreshAfterImport(): void {
        //Set to unfiled and last 30 days
        this.modelChild.showMode = 'U';
        this.setShowMode(this.modelChild.showMode);
        this.modelChild.createdDateRangeCode = 'L30D';

        //Refresh
        this.dsCollection.refresh();
        this.model.dirty = false;
    }
}
